var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9407 11.3378C19.5502 10.9473 18.917 10.9473 18.5265 11.3378L12.9661 16.8981L11.4737 15.4058C11.0832 15.0153 10.45 15.0153 10.0595 15.4058C9.66898 15.7962 9.66898 16.4295 10.0595 16.82L12.2591 19.0195C12.6496 19.4101 13.2828 19.4101 13.6733 19.0195L19.9407 12.7519C20.3312 12.3615 20.3312 11.7283 19.9407 11.3378Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8481 6.88497L15.5112 0.140542C15.3566 0.0485534 15.1799 0 15 0C14.82 0 14.6434 0.0485534 14.4887 0.140542L3.15182 6.88497C3.00287 6.97361 2.87951 7.09942 2.79383 7.25009C2.70815 7.40076 2.6631 7.5711 2.66309 7.74443V11.5944C2.66309 19.7035 7.34824 27.1098 14.6389 29.9325C14.8712 30.0225 15.1287 30.0225 15.361 29.9325C22.6339 27.1169 27.3367 19.7266 27.3367 11.5944V7.74443C27.3368 7.5711 27.2917 7.40075 27.2061 7.25007C27.1204 7.0994 26.997 6.97359 26.8481 6.88497ZM25.3368 11.5944C25.3368 19.0561 21.0341 25.4115 14.9999 27.9225C8.96226 25.41 4.66318 19.0517 4.66318 11.5944V8.31314L15 2.16361L25.3368 8.31314L25.3368 11.5944Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.b66e8624d3da236d36447579a0baa771.svg";
export { ForwardRef as ReactComponent };